module.exports = __webpack_public_path__ + "static/img/8.de3627e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/3/8.jpg
// module id = GHTN
// module chunks = 1